<template>
    <div class="selected-filter-pills d-flex flex-wrap">
        <div
            v-for="filter in enabledSelectedFilter"
            :key="filter.label"
            class="filter-pill d-flex align-items-center"
        >
            <div class="d-flex justify-content-between filter-content">
                <span
                    class="filter-text d-flex flex-column justify-content-center"
                    :class="
                        filter.label === 'Suv'
                            ? 'text-uppercase'
                            : 'text-capitalize'
                    "
                >
                    {{ filter.label }}
                </span>
                <b-link
                    @click="clearFilter(filter)"
                    class="close-icon d-flex flex-column justify-content-center"
                    :aria-label="`Remove filter for ${filter.label}`"
                >
                    <i class="material-icons">
                        close
                    </i>
                </b-link>
            </div>
        </div>
    </div>
</template>

<script>
import selectedFilterMixin from "./mixins/selectedFilterMixin";

export default {
    mixins: [selectedFilterMixin],
    props: {
        value: {
            type: Array,
            required: true
        }
    },
    methods: {
        clearFilter(filter) {
            const newSelectedFilters = this.value.map(f => {
                if (f.name === filter.name) {
                    if (f.type === "list") {
                        f.value = f.value.filter(v => v !== filter.value);
                    } else if (f.type === "boolean") {
                        f.value = false;
                    } else if (f.type === "range") {
                        f.value.min = null;
                        f.value.max = null;
                    } else {
                        f.value = null;
                    }
                }

                return f;
            });

            this.$emit("input", newSelectedFilters);
        }
    }
};
</script>

<style lang="scss">
.selected-filter-pills {
    .filter-pill {
        background-color: #c3002f;
        color: #fff;
        font-size: 12px;
        padding: 5px 5px 5px 10px;
        margin: 4px;
        height: 24px;
        max-width: 100%;

        .filter-text {
            margin-right: 10px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .close-icon {
            color: #fff;
            opacity: 0.5;
            font-weight: 500;

            &:hover {
                opacity: 1;
            }

            i {
                font-size: 20px;
            }
        }
    }
}
</style>
